import genericStore from "../generic_store";

export default {
    namespaced: genericStore.namespaced,
    state: {
        ...genericStore.state,
        endpoint: "banners",
        object: "banner",
        header: [
            { text: "Título", value: "title" },
            { text: "Subtítulo", value: "subtitle" },
            { text: "Url", value: "url" },
            { text: "Foto", value: "banner_picture" },
            { text: "Acciones", value: "actions", sortable: false }
        ],
    },
    mutations: {
        ...genericStore.mutations
    },
    actions: {
        ...genericStore.actions
    },
    getters: {
        ...genericStore.getters
    }
};
